var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechCosmetics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color_11_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "230.8,263.9 269.2,263.9 269.2,226.9 307.7,226.9 307.7,190 269.2,190 269.2,153 230.8,153  230.8,190 192.3,190 192.3,226.9 230.8,226.9  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "neutral_15_",
    className: "st3",
    d: "M375.1,23.7H124.9c-5.3,0-9.6,4.1-9.6,9.2c0,213.8,49.8,327.1,57.7,343.7v68.2 c0,9.4,7.5,31.3,77,31.3c67,0,77-20.2,77-32.3v-67.3c7.9-16.6,57.7-129.1,57.7-343.8C384.7,27.9,380.4,23.7,375.1,23.7z M307.7,444 c0,2.9-9.8,13.8-57.7,13.8c-52.6,0-57.7-12.9-57.7-12.9v-56.4c11.1,2.9,29,5.5,57.9,5.5c28.7,0,46.5-2.6,57.6-5.5V444z  M309.8,368.3c-4.3,2-19.5,7.2-59.6,7.2c-41,0-56.2-5.5-59.9-7.1c-7.1-15.4-48.5-112.4-54.9-289.3h229.2 C358.3,255.9,317,352.6,309.8,368.3z M365.1,60.7H134.9c-0.1-6.1-0.2-12.2-0.3-18.5h230.8C365.4,48.5,365.3,54.6,365.1,60.7z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechCosmetics;